module.exports = __webpack_public_path__ + "static/media/racecheck_logo_white.8e21ed85.svg";